import { styled } from '@mui/material/styles'
import FormControlLabel from '@mui/material/FormControlLabel'
import { SwitchProps } from '@mui/material/Switch'
import { Grid, Switch as MUISwitch } from '@mui/material'
import { Controller } from 'react-hook-form'
import { memo } from 'react'

const IOSSwitch = styled((props: SwitchProps) => (
  <MUISwitch
    focusVisibleClassName=".Mui-focusVisible"
    disableRipple
    {...props}
  />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor:
          theme.palette.mode === 'dark' ? '#2ECA45' : theme.palette.primary,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}))

interface ISwitchProps extends SwitchProps {
  form: any
  label: string
  formField: string
  col: number
}

const Switch = (props: ISwitchProps) => {
  const { form, label, formField, col } = props

  return (
    <Grid item sm={col}>
      <Controller
        name={formField}
        control={form.control}
        render={({ field: { ref, value, ...field } }) => (
          <FormControlLabel
            control={<IOSSwitch sx={{ m: 1 }} />}
            label={label}
            checked={value}
            {...field}
          />
        )}
      />
    </Grid>
  )
}

export default memo(Switch)
